import { ReactNode, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

interface Props {
  selectedFiles: (uploadedFiles: FileProps[]) => void;
  children: ReactNode;
}

export interface FileProps extends File {
  name: string;
  preview?: string;
}

export const DropzoneComponent = ({ children, selectedFiles }: Props) => {
  const onDrop = useCallback((acceptedFiles: FileProps[]) => {
    acceptedFiles.forEach((item: FileProps) => {
      item.preview = URL.createObjectURL(item);
    });

    selectedFiles(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div
      {...getRootProps()}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <input {...getInputProps()} />
      {children}
    </div>
  );
};
